import React from "react";
import { Link } from "react-router-dom";
import { AUTH_ORIGIN, loginHref } from "../../lib/authOrigin";

/**
 * SigninLink — single-source Sign In navigation for the marketing
 * surface (LandingV1 + LandingV2 + shared Header).
 *
 * Behavior:
 * * When ``REACT_APP_AUTH_ORIGIN`` is set (marketing build), renders
 *   a plain anchor to ``${AUTH_ORIGIN}/login`` so the browser leaves
 *   the marketing host and lands on the canonical app host.
 * * Otherwise renders a react-router ``<Link to="/login">`` so the
 *   app build preserves normal same-origin navigation.
 *
 * Props: any anchor / Link props (``className``, ``onClick``,
 * ``data-testid``, ``children``, etc.) are forwarded verbatim.
 */
export function SigninLink({ children, onClick, className, ...rest }) {
  if (AUTH_ORIGIN) {
    return (
      <a
        href={loginHref()}
        onClick={onClick}
        className={className}
        {...rest}
      >
        {children}
      </a>
    );
  }
  return (
    <Link
      to="/login"
      onClick={onClick}
      className={className}
      {...rest}
    >
      {children}
    </Link>
  );
}

export default SigninLink;
